
const CartEmpty = () => {
  return (
    <>
      <div className="min-h-[50vh] flex justify-center items-center">
        <div className="flex flex-col h-full justify-center items-center">
          <h1 className="font-bold text-2xl flex justify-center mt-[-80px]">Your cart is empty</h1>
        </div>
      </div>
    </>
  );
};

export default CartEmpty;
